import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";

const ReturnPolicy = () => {
  return (
    <>
      <Navbar />

      {/* Page Header */}
      <div style={styles.header}>
        <div style={styles.container}>
          <h1 style={styles.title}>Return Policy Page</h1>
          <div style={styles.breadcrumb}>
            Home / <span style={styles.active}>“Return Policy”</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={styles.contentWrapper}>
        <div style={styles.container}>

          <p>
            At Z1 Technology, we strive to ensure a smooth and satisfying shopping experience. However, if you are not fully satisfied with your purchase, our Return Policy allows you to request a return or replacement under the conditions outlined below.
          </p>

          <Section
            title="1. Eligibility for Returns"
            text="Products can be returned or exchanged if they meet the following conditions:"
            list={[
              "The return request is made within [Insert Days, e.g., 7 days] of receiving the product.",
              "The product is unused, unwashed, and in its original packaging with all tags, labels, and accessories intact.",
              "The product is in the same condition as delivered, without any damage or alteration.",
            ]}
          />

          <Section
            title="2. Non-Returnable Products"
            text="Certain products cannot be returned. These include:"
            list={[
              "Perishable goods such as food, groceries, and flowers.",
              "Personal hygiene products like undergarments, cosmetics, and toiletries.",
              "Products sold as part of clearance sales, final sale, or items marked as non-returnable in the product description.",
              "Customized, personalized, or made-to-order items.",
            ]}
          />

          <Section
            title="4. Return Shipping"
            text="To initiate a return, follow these steps:"
            list={[
              "For products that are damaged, defective, or incorrect, return shipping is free, and we will arrange for a courier to pick up the item from your location.",
              "If you are returning a product due to personal reasons (e.g., change of mind), you will be responsible for the return shipping costs.",
            ]}
          />

          <Section
            title="5. Damaged or Defective Products"
            text="If you receive a damaged or defective product, please notify us immediately by contacting our customer service at  071590132. You must provide photo evidence of the damage or defect. We will arrange for a free return and either offer a replacement or a full refund, depending on your preference."
          />

          <Section title="6. Contact Us">
            <p>
              If you have any questions or concerns regarding these Return Policy, please contact us at:
            </p>

            <p style={{ marginTop: "16px" }}>
              <strong>Z.One Technology & Trade Pvt. Ltd.</strong><br />
              Siddharthanagar-12, Bhairahawa, Lumbini, Nepal<br />
              Email: contact@sajilobazar.com<br />
              Phone: 071590132, 9857050123
            </p>
          </Section>
        </div>
      </div>

      <Footer />
    </>
  );
};

const Section = ({ title, text, list, children }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    {text && <p>{text}</p>}
    {list && (
      <ul>
        {list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )}
    {children}
  </div>
);

const styles = {
  header: {
    padding: "40px 0",
    background: "#ffffff",
    borderBottom: "1px solid #e5e7eb",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "6px",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#6b7280",
  },
  active: {
    color: "#2563eb",
  },
  contentWrapper: {
    padding: "40px 0",
    background: "#ffffff",
  },
  section: {
    marginTop: "28px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "700",
    marginBottom: "8px",
  },
};

export default ReturnPolicy;
